module.exports = __webpack_public_path__ + "assets/img/1-1.2017d9b2.svg";